import type { Language } from '@/config/objects/languages';
import { useOutletContext } from 'react-router-dom';

interface LanguageContext {
  language: Language | undefined;
  isLoading: boolean;
}

export function useLanguageContext() {
  return useOutletContext<LanguageContext>();
}
